import React from 'react';
import { clsx } from 'clsx';
import { useTabValue } from '@/hooks/tab';
import Header from '@/components/organisms/header/Header';
import Sidebar from '@/components/organisms/sidebar/Sidebar';
import Section from '@/components/organisms/section/Section';
import styles from './Layout.module.scss';

const View: React.FC = () => {
  const [inputValue] = useTabValue();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <Header />
      </div>
      {inputValue && (
        <div className={styles.bottom}>
          <div className={clsx([styles.left])}>
            <Sidebar />
          </div>
          <div className={styles.right}>
            <div className={styles.rightInner}>
              <Section />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default View;
